// Unpublished Work © 2023-2024 Deere & Company.

export const BODY_FONT_STYLE = {
    fontFamily: '"Open Sans", -apple-system, blinkmacsystemfont, "Helvetica Neue", arial, sans-serif'
};

export const LABEL_FONT_STYLE = {
    ...BODY_FONT_STYLE,
    fontWeight: 'bold'
};
